var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.node != 'undefined')?_c('li',{staticClass:"node-tree",class:[{'root':_vm.node.ness_level==1}]},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.node.name))]),(_vm.node.children && _vm.node.children.length)?_c('ul',_vm._l((_vm.node.children),function(child){return _c('ReBranchTreeNode',{attrs:{"node":child}})}),1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }